(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-media-gallery"] && !Shopify.designMode) return;
  try {
    class MediaGalleryLoadMore {
    constructor() {
      this.init();
    }

    init() {
      this.bindEvents();
    }

    bindEvents() {
      // Check if load more buttons exist
      const loadMoreButtons = document.querySelectorAll('[data-load-more-button]');
      console.log('Load more buttons found:', loadMoreButtons.length);

      document.addEventListener('click', (e) => {
        if (e.target.matches('[data-load-more-button]')) {
          e.preventDefault();
          console.log('Load more button clicked');
          this.handleLoadMore(e.target);
        }
      });
    }

    handleLoadMore(button) {
      // Find the grid by looking for the closest media-gallery container and then finding the grid within it
      const mediaGallery = button.closest('media-gallery');
      if (!mediaGallery) {
        console.log('Media gallery not found');
        return;
      }

      const grid = mediaGallery.querySelector('.media-gallery__grid--load-more');
      if (!grid) {
        console.log('Grid not found');
        return;
      }

      const hiddenItems = grid.querySelectorAll('.media-gallery__item--hidden');
      console.log('Hidden items found:', hiddenItems.length);

      if (hiddenItems.length > 0) {
        // Show all hidden items
        hiddenItems.forEach((item) => {
          item.classList.remove('media-gallery__item--hidden');
        });

        // Hide the load more button
        const wrapper = button.closest('.media-gallery__load-more-wrapper');
        if (wrapper) {
          wrapper.style.display = 'none';
        }
      }
    }
  }

  // Initialize load more functionality
  new MediaGalleryLoadMore();
  } catch(e) { console.error(e); }
})();

})();
